import React, { Dispatch, useReducer } from 'react'
import { Actions, initialState, IState, reducer } from './reducer'

interface IContextProps {
  state: IState
  dispatch: Dispatch<Actions>
}

export const Store = React.createContext({} as IContextProps)

export function StateProvider(props: any) {
  const [state, dispatch] = useReducer(reducer, initialState)

  const value = { state, dispatch }
  return <Store.Provider value={value}>{props.children}</Store.Provider>
}
